module.exports = __webpack_public_path__ + "static/media/sf_pro-medium.d09193c2.woff";